import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { SkillDocumentResponse } from '../../../models/skill-learning.model';

type SkillDocumentInput = SkillDocumentResponse | null;

@Component({
  selector: 'app-skill-document-card',
  templateUrl: './skill-document-card.component.html',
  styleUrls: ['./skill-document-card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillDocumentCardComponent {

  @Input() document: SkillDocumentInput = null;
  @Input() isAvailable: boolean = false;
  @Input() fallbackName: string | null = null;
  @Input() emptyLabel: string = 'SKILL_LEARNING_DOCUMENT_CARD_EMPTY';
  @Input() downloadLabel: string = 'SKILL_LEARNING_DOCUMENT_CARD_DOWNLOAD';
  @Input() showDownloadButton: boolean = true;
  @Input() showDisabledDownloadButton: boolean = false;

  @Output() downloadRequested = new EventEmitter<void>();

  get displayName(): string {
    if (this.document && this.document.fileName) {
      return this.document.fileName;
    }
    return this.fallbackName;
  }

  get extensionLabel(): string {
    if (!this.document || !this.document.fileExtension) {
      return '';
    }
    return this.document.fileExtension.toUpperCase();
  }

  get sizeLabel(): string {
    if (!this.document) {
      return '';
    }
    return this.formatSize(this.document.size);
  }

  get hasMeta(): boolean {
    return !!this.extensionLabel || !!this.sizeLabel;
  }

  get shouldShowEmptyLabel(): boolean {
    return !this.isAvailable && !this.showDisabledDownloadButton;
  }

  onDownload(): void {
    if (this.isAvailable) {
      this.downloadRequested.emit();
    }
  }

  private formatSize(size: number | null | undefined): string {
    if (typeof size !== 'number' || isNaN(size) || size < 0) {
      return '';
    }
    if (size < 1024) {
      return size + ' B';
    }
    if (size < 1048576) {
      return (size / 1024).toFixed(1) + ' KB';
    }
    return (size / 1048576).toFixed(1) + ' MB';
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/shared/skill-document-card/skill-document-card.component.ts